import { TrendingUp, TrendingDown, Minus, Sparkles, Activity } from 'lucide-react'
import type { TrendDirection } from '../../../../types'
import { TREND_COLORS, TREND_BG_COLORS, TREND_LABELS } from '../../../../constants/colors'

interface TrendBadgeProps {
  trend: TrendDirection
  size?: 'sm' | 'md'
  showIcon?: boolean
}

const trendIcons: Record<TrendDirection, React.ReactNode> = {
  INCREASING: <TrendingUp className="w-3 h-3" />,
  DECREASING: <TrendingDown className="w-3 h-3" />,
  STABLE: <Minus className="w-3 h-3" />,
  NEW: <Sparkles className="w-3 h-3" />,
  IRREGULAR: <Activity className="w-3 h-3" />,
}

export default function TrendBadge({ trend, size = 'sm', showIcon = true }: TrendBadgeProps) {
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm'

  return (
    <span
      className={`inline-flex items-center gap-1 font-medium rounded-full ${sizeClasses}`}
      style={{
        backgroundColor: TREND_BG_COLORS[trend],
        color: TREND_COLORS[trend],
      }}
    >
      {showIcon && trendIcons[trend]}
      {TREND_LABELS[trend]}
    </span>
  )
}
